import israeFlag from "../assets/Flags/israelFlag.jpg";
import usFlag from "../assets/Flags/usFlag.jpg";
import russiaFlag from "../assets/Flags/russiaFlag.jpg";
import arabFlag from "../assets/Flags/arabFlag.png";
import MYBEE_ENERGY_LOGO from "../assets/PluginsLogo/MYBEE_ENERGY_LOGO.svg";
import MYBEE_SERVICE_LOGO from "../assets/PluginsLogo/MYBEE_SERVICE_LOGO.svg";
import MYBEE_METER_LOGO from "../assets/PluginsLogo/MYBEE_METER_LOGO.svg";
import MYBEE_SYSTEM_LOGO from "../assets/PluginsLogo/MYBEE_SYSTEM_LOGO.svg";
import { DEPARTMENT_MANAGER, MANAGER, SU_ADMIN } from "./roles";

export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_FOR_API_FORMAT = "MM-DD-YYYY";
export const API_DATE_FORMAT = "DD.MM.YYYY";
export const API_DATE_MINI_FORMAT = "DD.MM.YY";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DATE_TIME_MINI_FORMAT = `${API_DATE_MINI_FORMAT} ${TIME_FORMAT}`;

export const COLORS = [
  { id: "#FFFFFF", name: "WHITE" },
  { id: "#FFC6C6", name: "LIGHT_PINK" },
  { id: "#FAEDCE", name: "LIGHT_YELLOW" },
  { id: "#E0E5B6", name: "PALE_GREEN" },
  { id: "#D1E9F6", name: "LIGHT_BLUE" },
  { id: "#F6F5F2", name: "OFF_WHITE" },
  { id: "#E0AED0", name: "LIGHT_LAVENDER" },
  { id: "#FF9B9B", name: "SOFT_RED" },
  { id: "#A1CCD1", name: "SOFT_CYAN" },
  { id: "#EEC373", name: "SOFT_GOLD" },
  { id: "#C8E3D4", name: "SOFT_MINT" },
  { id: "#C9CBFF", name: "SOFT_LILAC" },
];

export const MC_ST_LOCATION = {
  STORAGE: "STORAGE",      // מחסן
  INSTALLATION: "INSTALLATION", // בתהליך התקנה

  IN_TECHNICIAN: "ITECHNICIAN",// אצל טכנאי
  LAB: "LAB",              // מעבדה
  REPAIR: "REPAIR",        // בתיקון
  CUSTOMER: "CUSTOMER",    // אצל לקוח
};

export const MC_DEVICE_TYPE = {
  NONE: "NONE",
  AIR_CONDITIONER: "AIR_CONDITIONER",   // מזגן / מערכת מיזוג
  LIGHTING: "LIGHTING",                 // תאורה
  WATER_PUMP: "WATER_PUMP",             // משאבת מים
  BOILER: "BOILER",                     // דוד חימום
  GENERATOR: "GENERATOR",               // גנרטור
  COMPRESSOR: "COMPRESSOR",             // מדחס
  ELEVATOR: "ELEVATOR",                 // מעלית
  REFRIGERATION: "REFRIGERATION",       // מקרר תעשייתי / חדר קירור
  RELAY: "RELAY",                       // ממסר/ממסר פיקוד
  HVAC: "HVAC",                         // מערכת אוורור/חימום/קירור מרכזית
  GATE: "GATE",                         // שער חשמלי / מחסום
  SOLAR: "SOLAR",                       // מערכת סולארית
  FIRE_SYSTEM: "FIRE_SYSTEM",           // מערכת גילוי/כיבוי אש
  IRRIGATION: "IRRIGATION",             // מערכת השקיה
  MACHINE: "MACHINE",                   // מכונה תעשייתית כללית
  STEAM_SYSTEM: "STEAM_SYSTEM",     // מערכת קיטור
  ELECTRICAL_ROOM: "ELECTRICAL_ROOM",   // חדר חשמל
};

export const MC_SOFTWARE_TYPE = {
  NONE: "NONE",
  B1_0: "B1.0",
  B1_1: "B1.1",
  B1_3: "B1.3",
  B1_4: "B1.4",
  B1_5: "B1.5",
  B1_6: "B1.6",
  B1_7: "B1.7",
  B1_8: "B1.8",
  B1_9: "B1.9",

  B2_0: "B2.0",
  B2_1: "B2.1",
  B2_2: "B2.2",
}

export const MC_REPORTS_TEMP = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_1,
  MC_SOFTWARE_TYPE.B1_4,
  MC_SOFTWARE_TYPE.B1_5,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
]

export const MC_REPORTS_DHT = [
  MC_SOFTWARE_TYPE.B1_8,
]

export const MC_WITH_NOTIFICATIONS = [
  MC_SOFTWARE_TYPE.B2_2,
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_4,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_7,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
  MC_SOFTWARE_TYPE.B2_0,
  MC_SOFTWARE_TYPE.B2_1,
];

export const MC_WITH_WEEKLY_TIMES = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_1,
  MC_SOFTWARE_TYPE.B1_3,
  MC_SOFTWARE_TYPE.B1_4,
  MC_SOFTWARE_TYPE.B1_5,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_7,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
]

export const MC_WIHT_RELAY = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_1,
  MC_SOFTWARE_TYPE.B1_3,
  MC_SOFTWARE_TYPE.B1_4,
  MC_SOFTWARE_TYPE.B1_5,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_7,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
]

export const MC_WIHT_DELTAT = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_6,
]

export const MC_WITH_TEMP_REPORTS = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_1,
  MC_SOFTWARE_TYPE.B1_4,
  MC_SOFTWARE_TYPE.B1_5,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
]

export const MC_WITH_SENSOR1_OFFSET = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_1,
  MC_SOFTWARE_TYPE.B1_4,
  MC_SOFTWARE_TYPE.B1_5,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
  MC_SOFTWARE_TYPE.B2_0,
]

export const MC_WITH_SENSOR2_OFFSET = [
  MC_SOFTWARE_TYPE.B1_0,
  MC_SOFTWARE_TYPE.B1_5,
  MC_SOFTWARE_TYPE.B1_6,
  MC_SOFTWARE_TYPE.B1_8,
  MC_SOFTWARE_TYPE.B1_9,
]

export const MC_HEALTH_STATUS = {
  OK: "OK",
  FAULTY: "FAULTY",
  DECOMMISSIONING: "DECOMMISSIONING",
  DECOMMISSIONED: "DECOMMISSIONED",
};

export const MC_MODEL = {
  MC_2S_1R_MODEM: "MC-2S-1R-MODEM",
  MC_2S_2R_MODEM: "MC-2S-2R-MODEM",
  MC_2S_B_MODEM: "MC-2S-B-MODEM",
};

export const MC_REQUEST_STATUS = {
  WAITING_FLASH: "WAITING_FLASH",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED"
}

export const MC_FAULT_TYPE = {
  CLOGGED_FILTER: "CLOGGED_FILTER",
  COMPRESSOR_NOT_STOP: "COMPRESSOR_NOT_STOP",
  LACK_GAS: "LACK_GAS",
  WATER_LEVEL_HIGH: "WATER_LEVEL_HIGH",
  WATER_LEVEL_LOW: "WATER_LEVEL_LOW",
  WATER_LEAK_DETECTED: "WATER_LEAK_DETECTED",
  DOOR_OPEN: "DOOR_OPEN",
  WINDOW_OPEN: "WINDOW_OPEN",
  EMERGENCY_STOP: "EMERGENCY_STOP",
  FIRE_ALARM: "FIRE_ALARM",
  GENERIC_FAULT: "GENERIC_FAULT",
}

export const LANGUAGES_LIST = [
  { id: 1, i18Key: "HE", code: "he", dir: "rtl", img: israeFlag },
  { id: 2, i18Key: "EN", code: "en", dir: "ltr", img: usFlag },
  { id: 3, i18Key: "AR", code: "ar", dir: "rtl", img: arabFlag },
  { id: 4, i18Key: "RU", code: "ru", dir: "ltr", img: russiaFlag },
];

export const PLUGIN_NAME = {
  CALENDAR: "CALENDAR",
  SERVICES_CALL: "SERVICES_CALL",
  CONTACT_US: "CONTACT_US",
  ANALYTICS: "ANALYTICS",
  RECOMMEND: "RECOMMEND",
  METER_READ: "METER_READ",
  MICRO_CONTROLLERS: "MICRO_CONTROLLERS",
  EMPLOYEES: "EMPLOYEES",
  SUPPLIERS: "SUPPLIERS",
  CLIENTS: "CLIENTS",
  ITEMS: "ITEMS",
  MINI_SITE: "MINI_SITE",
  TEMP_REPORT: "TEMP_REPORT",
  CHECK_LIST: "CHECK_LIST",
  SYSTEM: "SYSTEM",
};

export const PLUGIN_PROD_LIST = [
  { sysName: PLUGIN_NAME.MICRO_CONTROLLERS, logo: MYBEE_ENERGY_LOGO },
  { sysName: PLUGIN_NAME.SERVICES_CALL, logo: MYBEE_SERVICE_LOGO },
  { sysName: PLUGIN_NAME.METER_READ, logo: MYBEE_METER_LOGO },
  { sysName: PLUGIN_NAME.SYSTEM, logo: MYBEE_SYSTEM_LOGO },
]

export const DAY_OF_WEEK = [
  { day: 0, name: "SUNDAY" },
  { day: 1, name: "MONDAY" },
  { day: 2, name: "TUESDAY" },
  { day: 3, name: "WEDNESDAY" },
  { day: 4, name: "THURSDAY" },
  { day: 5, name: "FRIDAY" },
  { day: 6, name: "SATURDAY" },
];

export const AC_COMMANDS_TYPE = {
  ELECTRA_1: "ELECTRA_1",
  TADIRAN_1: "TADIRAN_1",
  TORNADO_1: "TORNADO_1",
}


export const METER_TYPE = {
  ELECTRICITY: 1,
  WATER: 2,
  GAS: 3,
  CHLORINE: 4,
}

export const BIZ_TYPE = {
  SERVICE_PROVIDER: "service_provider",
  MAINTENANCE_DEPARTMENT: "maintenance_department",
  HOTEL: "hotel",
  FACTORY: "factory"
}

export const BIZ_STATUS = {
  ACTIVE: "ACTIVE",
  PILOT: "PILOT",
  NOT_ACTIVE: "NOT_ACTIVE",
  BLOCKED: "BLOCKED",
  PENDING_DELETE: "PENDING_DELETE",
}

export const PLATFORM_TYPE = {
  API: 1,
  BO: 2,
  MC: 3,
  WEB: 4,
  SERVER: 5,
  MQTT: 6,
}

export const SHORTCUT_NAVIGATE_TO = [
  {
    pluginName: PLUGIN_NAME.CALENDAR,
    title: "CALENDAR",
    path: "/Calendar",
  },
  {
    pluginName: PLUGIN_NAME.SERVICES_CALL,
    title: "SERVICE_CALL_ACTIVE",
    path: "/Service-Call/Active",
  },
  {
    pluginName: PLUGIN_NAME.SERVICES_CALL,
    title: "SERVICE_CALL_HISTORY",
    path: "/Service-Call/History",
    showRoles: DEPARTMENT_MANAGER,
  },
  {
    pluginName: PLUGIN_NAME.SERVICES_CALL,
    title: "CREATE_SERVICE_CALL",
    path: "CREATE_SERVICE_CALL",
  },
  {
    pluginName: PLUGIN_NAME.SERVICES_CALL,
    title: "SERVICE_CALL_APPROVAL",
    path: "/Service-Call/Approval",
    showRoles: DEPARTMENT_MANAGER,
  },
  {
    pluginName: PLUGIN_NAME.MICRO_CONTROLLERS,
    title: "CONTROL_AND_MONITORING",
    path: "/Control-And-Monitoring",
  },
  {
    pluginName: PLUGIN_NAME.METER_READ,
    title: "METER_READING",
    path: "/Meter-Read",
  },
  {
    pluginName: PLUGIN_NAME.CHECK_LIST,
    title: "CHECK_LIST",
    path: "/Check-List",
  },
  {
    pluginName: PLUGIN_NAME.SMART_QR,
    title: "SMART_QR",
    path: "/Smart-Qr",
  },
  {
    pluginName: PLUGIN_NAME.CLIENTS,
    title: "CLIENTS",
    path: "/Clients",
    showRoles: MANAGER,
  },
  {
    pluginName: PLUGIN_NAME.ITEMS,
    title: "ITEMS",
    path: "/Items",
    showRoles: MANAGER,
  },
  {
    pluginName: PLUGIN_NAME.EMPLOYEES,
    title: "EMPLOYEES",
    path: "/Employees",
    showRoles: DEPARTMENT_MANAGER,
  },
  {
    pluginName: PLUGIN_NAME.EMPLOYEES,
    title: "DEPARTMENTS",
    path: "/Departments",
    showRoles: MANAGER,
  },
  {
    pluginName: PLUGIN_NAME.MICRO_CONTROLLERS,
    title: "AREAS",
    path: "/Areas",
    showRoles: MANAGER,
  },


  /** su admin */
  {
    title: "PLANS_MANAGEMENT",
    path: "/Plans-Manager",
    showRoles: SU_ADMIN,
  },
  {
    title: "PLUGINS_MANAGER",
    path: "/Plugins-Manager",
    showRoles: SU_ADMIN,
  },
  {
    title: "MICRO_CONTROLLERS_MANAGER",
    path: "/Micro-Controllers-Manager",
    showRoles: SU_ADMIN,
  },
  {
    title: "LOGS",
    path: "/Logs",
    showRoles: SU_ADMIN,
  },
]

//** Electron command */
export const IS_SYSTEM = "IS_SYSTEM"
export const FLASHING_MC = "FLASHING_MC"
export const UPDATE_MC = "UPDATE_MC";
export const TESTING_MC = "TESTING_MC"
export const PRINT_QR = "PRINT_QR"
export const PRINT_MC_INSTALL_INFO = "PRINT_MC_INSTALL_INFO"
export const GET_MC_GUID = "GET_MC_GUID"
